module.exports = __webpack_public_path__ + "img/ícone-carta.49c8fabb.svg";